import PropTypes from "prop-types"
import { map, size, get, includes } from "lodash"
import { List, ListItem, ListItemText, ListItemAvatar, Checkbox } from "@mui/material"

export default function PortfolioList({ isOpPro, portfolios, togglePortfolio, availableResourceSlots, toImport }) {
  function isChecked(portfolio) {
    return includes(toImport, portfolio.ezePortfolioId)
  }

  return <>
    <List>
      {map(portfolios, (portfolio) => {
        const omegaPointPortfolioName = get(portfolio, "portfolio.name")
        const notEnoughResources = isOpPro && (availableResourceSlots === 0 || availableResourceSlots - size(toImport) <= 0)
        // if there's an Omega Point portfolio associated with this Eze portfolio, disable the checkbox since it's already mapped
        const isDisabled = !!omegaPointPortfolioName || (!isChecked(portfolio) && notEnoughResources)
        return <ListItem key={portfolio.ezePortfolioId} disabled={isDisabled}>
          <ListItemAvatar>
            <Checkbox disabled={isDisabled} color="primary" checked={isChecked(portfolio)} onChange={() => togglePortfolio(portfolio)} />
          </ListItemAvatar>
          <ListItemText primary={portfolio.ezePortfolioId} secondary={omegaPointPortfolioName && `Mapped to portfolio: ${omegaPointPortfolioName}`} />
        </ListItem>
      })}
    </List>
    {!size(portfolios) && <div>No portfolios found</div>}
  </>
}

PortfolioList.propTypes = {
  portfolios: PropTypes.arrayOf(
    PropTypes.shape({
      ezePortfolioId: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
  togglePortfolio: PropTypes.func.isRequired,
  availableResourceSlots: PropTypes.number,
  toImport: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  isOpPro: PropTypes.bool.isRequired,
}
